export default {"src":"https://fishbrain.com/_next/static/media/tilapia.aa23b1ef.svg","height":115,"width":230,"blurWidth":0,"blurHeight":0};